import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import crmService from "../../crmConfig.json";
import { crmAxios } from "../../app/crmApi";

const initialState = {
    notifications: [],
    unreadCount: 0,
    loading: false,
};

export const fetchNotificationsAsync = createAsyncThunk(
    "crmNotification/fetch",
    async (params, { rejectWithValue }) => {
        try {
            const res = await crmAxios.get(crmService.notifications, { params });
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data);
        }
    }
);

export const fetchUnreadCountAsync = createAsyncThunk(
    "crmNotification/fetchUnreadCount",
    async (_, { rejectWithValue }) => {
        try {
            const res = await crmAxios.get(`${crmService.notifications}/unread-count`);
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data);
        }
    }
);

export const markNotificationReadAsync = createAsyncThunk(
    "crmNotification/markRead",
    async (id, { rejectWithValue }) => {
        try {
            const res = await crmAxios.patch(`${crmService.notifications}/${id}/read`);
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data);
        }
    }
);

export const markAllNotificationsReadAsync = createAsyncThunk(
    "crmNotification/markAllRead",
    async (_, { rejectWithValue }) => {
        try {
            const res = await crmAxios.patch(`${crmService.notifications}/read-all`);
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data);
        }
    }
);

const crmNotificationSlice = createSlice({
    name: "crmNotification",
    initialState,
    reducers: {
        resetNotifications: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNotificationsAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchNotificationsAsync.fulfilled, (state, { payload }) => {
                state.loading = false;
                if (payload?.success) {
                    state.notifications = payload.data.notifications;
                    state.unreadCount = payload.data.unreadCount;
                }
            })
            .addCase(fetchNotificationsAsync.rejected, (state) => {
                state.loading = false;
            })
            .addCase(fetchUnreadCountAsync.fulfilled, (state, { payload }) => {
                if (payload?.success) state.unreadCount = payload.data.count;
            })
            .addCase(markNotificationReadAsync.fulfilled, (state, { payload }) => {
                if (payload?.success) {
                    state.notifications = state.notifications.map((n) =>
                        n.id === payload.data.id ? { ...n, isRead: true } : n
                    );
                    state.unreadCount = Math.max(0, state.unreadCount - 1);
                }
            })
            .addCase(markAllNotificationsReadAsync.fulfilled, (state, { payload }) => {
                if (payload?.success) {
                    state.notifications = state.notifications.map((n) => ({
                        ...n,
                        isRead: true,
                    }));
                    state.unreadCount = 0;
                }
            });
    },
});

export const { resetNotifications } = crmNotificationSlice.actions;

export const selectNotifications = (state) => state.crmNotification.notifications;
export const selectUnreadCount = (state) => state.crmNotification.unreadCount;
export const selectNotificationsLoading = (state) => state.crmNotification.loading;

export default crmNotificationSlice.reducer;
